import { SxProps, Theme } from '@mui/material/styles';

export const modalStyles = {
	paper: (fullHeight: boolean): SxProps<Theme> => ({
		maxHeight: '90dvh',
		height: fullHeight ? '90dvh' : 'unset'
	}),

	title: {
		px: 2,
		py: 2,
		color: 'text.fadedPrimary'
	},

	titleRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: 1,
		width: '100%',
		fontSize: '1.25rem'
	},

	titleSlot: {
		flex: 1,
		minWidth: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	},

	titleEnd: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 1,
		flexShrink: 0
	},

	body: (hasFooter: boolean): SxProps<Theme> => ({
		px: 2,
		pt: 0,
		pb: hasFooter ? 0 : 2,
		overflowY: 'auto'
	}),

	footer: {
		px: 2,
		py: 2
	}
};
